import { QueryClient } from '@tanstack/react-query';

/**
 * Shared defaults for server state: Strapi is source of truth after mutations.
 * No refetch on window focus — list grids refresh via explicit refetch / invalidation.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 60 * 1000,
        gcTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
        retry: 1,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
